// extracted by mini-css-extract-plugin
export default {"textIconGroup":"TextIconGroup_textIconGroup__poLxr","infoText":"TextIconGroup_infoText__zX8wH","labelIcon":"TextIconGroup_labelIcon__4aS--"};